import { PartWithChildrenDto } from "#modules/parts/infra/fetchPartWithChildren.api";
import { JobStatusSchema } from "shared";

export const isAllAssemblyAnalyzed = (
  assembly: PartWithChildrenDto | null | undefined,
): boolean => {
  if (!assembly) {
    return false;
  }

  const isPreviewLoading =
    !assembly.urlPng3D ||
    assembly.previewStatus === JobStatusSchema.enum.STANDBY ||
    assembly.previewStatus === JobStatusSchema.enum.PROCESSING;

  const isGltfLoading =
    !assembly.urlGltf ||
    assembly.gltfStatus === JobStatusSchema.enum.STANDBY ||
    assembly.gltfStatus === JobStatusSchema.enum.PROCESSING;

  const isEmbeddingLoading =
    !assembly.hasTopologicalEmbedding ||
    assembly.topologicalEmbeddingStatus === JobStatusSchema.enum.STANDBY ||
    assembly.topologicalEmbeddingStatus === JobStatusSchema.enum.PROCESSING;

  const isAnalyzingPart =
    assembly.analyzeStatus === JobStatusSchema.enum.STANDBY ||
    assembly.analyzeStatus === JobStatusSchema.enum.PROCESSING;

  const areAllChildrenAnalyzed: boolean = assembly.children.every(
    (c) => isAllAssemblyAnalyzed(c as PartWithChildrenDto), // the children recursion is not well typed
  );

  return (
    !isPreviewLoading &&
    !isGltfLoading &&
    !isEmbeddingLoading &&
    !isAnalyzingPart &&
    areAllChildrenAnalyzed
  );
};
